module.exports = __webpack_public_path__ + "img/C2.5b202cee.jpg";